export const TOGGLE_SHOW_BOARD_TEAM = "TOGGLE_SHOW_BOARD_TEAM";
export const GET_BOARD_USERS_REQUEST = "GET_BOARD_USERS_REQUEST";
export const GET_BOARD_USERS_SUCCESS = "GET_BOARD_USERS_SUCCESS";
export const ADD_NEW_BOARD_USERS_SUCCESS = "ADD_NEW_BOARD_USERS_SUCCESS";
export const TOGGLE_ADMIN_SUCCESS = "TOGGLE_ADMIN_SUCCESS";
export const REMOVE_BOARD_MEMBER_SUCCESS = "REMOVE_BOARD_MEMBER_SUCCESS";
export const EDIT_BOARD_MEMBER_SUCCESS = "EDIT_BOARD_MEMBER_SUCCESS";
export const EMPTY_NEW_BOARD_MEMBER_STATE = "EMPTY_NEW_BOARD_MEMBER_STATE";
export const EMPTY_NEW_REMOVED_MEMBER_MEMBER_STATE = "EMPTY_NEW_REMOVED_MEMBER_MEMBER_STATE";
export const GET_USER_RATES = "GET_USER_RATES";
export const ADD_USER_RATES = "ADD_USER_RATES";
export const USER_WORKING_TIME_ID = "USER_WORKING_TIME_ID";
export const USER_ONLINE_TIME_ID = "USER_ONLINE_TIME_ID";
export const GET_USER_TIMES = "GET_USER_TIMES";
export const GET_ONLINE_USERS = "GET_ONLINE_USERS";
export const GET_USER_BOARD_GROUPS = "GET_USER_BOARD_GROUPS";
export const GET_BOARD_GROUPS = "GET_BOARD_GROUPS";
export const ADD_BOARD_GROUPS = "ADD_BOARD_GROUPS";
export const EDIT_BOARD_GROUP = "EDIT_BOARD_GROUP";
export const DELETE_BOARD_GROUP = "DELETE_BOARD_GROUP";
export const BOARD_ADMIN_OWNER_CHECK = "BOARD_ADMIN_OWNER_CHECK";
export const BOARD_PERMISSIONS = "BOARD_PERMISSIONS";
export const UG_PERMISSIONS = "UG_PERMISSIONS";
export const ADMIN_PERMISSION_TASKMAPS = "ADMIN_PERMISSION_TASKMAPS";